import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';

import { AppRoutingModule } from './app-routing.module';
import { PmacModule } from '@pubmatic/pmac';
import { PmccModule } from '@pubmatic/pmcc';
import { AppName, PendoModule, SessionManagerService, UiCoreModule } from '@pubmatic/ui-core';
import { AppComponent } from './app.component';
import { ConfigServiceProvider } from './config.service.provider';
import { HeaderComponent } from './common/components/header/header.component';
import { FormsModule } from '@angular/forms';
import { VideoToolHeaderComponent } from './common/components/video-tool-header/video-tool-header.component';
import { environment } from 'src/environments/environment';
import { LogoutComponent } from './pages/logout/logout.component';
import { TokenInterceptor } from './auth/token.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { APP_BASE_HREF } from '@angular/common';

declare var PubMatic: any;

export function sessionInitializer(sm: SessionManagerService) {
  return () => new Promise<void>((resolve: Function, reject: Function) => {
    // if (!sm.isInitialized()) {
    //   reject();
    //   sm.redirectToLogin(AppName.PUBLISHER);
    // } else {
      resolve();
    // }
  });
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    VideoToolHeaderComponent,
    LogoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PmacModule,
    PmccModule,
    UiCoreModule,
    FormsModule,
    OktaAuthModule,
    PendoModule.forRoot({
      pendoEnabled: PubMatic.config['pendoEnabled'],
      pendoApiKey: PubMatic.config['pendoApiKey']
    }),
  ],
  providers: [
    // { provide: APP_BASE_HREF, useValue: '/v2' },
    ConfigServiceProvider,
    SessionManagerService,
    {
      provide: APP_INITIALIZER,
      useFactory: sessionInitializer,
      deps: [SessionManagerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: OKTA_CONFIG,
      useValue: environment.okta
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
